import { render, staticRenderFns } from "./ViewShipmentEstimationComponent.vue?vue&type=template&id=b8ec7936"
import script from "./ViewShipmentEstimationComponent.vue?vue&type=script&lang=js"
export * from "./ViewShipmentEstimationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports